module.exports = __webpack_public_path__ + "img/ICONO2.f73bce83.png";